// extracted by mini-css-extract-plugin
module.exports = {"chatRevampContainer":"_1LBek","chatContainer":"_1K0Q_","needHelpText":"VmLl9","helpText":"tyGTX"};